module.exports = "/images/a776151212a3884dcf050ab2b61e4527.png";